var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "outbound-details-page" }, [
    _c("div", { staticClass: "progress" }, [
      _c("div", { staticClass: "track-title" }, [
        _c("div", { staticClass: "track-info" }, [
          _c("div", [_vm._v(_vm._s(_vm.selectItem.platformTrackName))]),
          _c("div", [_vm._v(_vm._s(_vm.selectItem.platformTrackNum))])
        ]),
        _c(
          "div",
          {
            staticClass: "track-btn",
            on: {
              click: function($event) {
                return _vm.copyBtn(_vm.selectItem.platformTrackNum)
              }
            }
          },
          [_vm._v("复制")]
        )
      ]),
      _c(
        "div",
        { staticClass: "step-box" },
        [
          _vm.expressDeliveryInfo.length > 0
            ? [
                _c("div", { staticClass: "step-title" }, [_vm._v("运输中")]),
                _c("div", { staticClass: "step-info" }, [
                  _vm._v(_vm._s(_vm.expressDeliveryInfo[0].context))
                ])
              ]
            : [
                _c("div", { staticClass: "step-title" }, [
                  _vm._v("暂无揽件信息")
                ]),
                _c("div", { staticClass: "step-info" }, [
                  _vm._v("该快递暂无揽件信息")
                ])
              ]
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "step-btn", on: { click: _vm.onclickViewAll } },
        [_vm._v("查看全部")]
      )
    ]),
    _c(
      "div",
      { staticClass: "device-box" },
      [
        _c("div", { staticClass: "device-box-title" }, [_vm._v("返厂设备")]),
        _vm._l(_vm.selectItem.deviceCountList, function(item, index) {
          return _c("div", { key: index, staticClass: "device-item" }, [
            _c("div", { staticClass: "left" }, [
              _c("div", { staticClass: "icon" }, [
                _c("img", { attrs: { src: item.url, alt: "" } })
              ]),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(item.deviceTypeName))
              ])
            ]),
            _c("div", { staticClass: "right" }, [
              _vm._v(_vm._s(item.count) + "台")
            ])
          ])
        })
      ],
      2
    ),
    _vm.selectItem.factoryConfirmedName
      ? _c("div", { staticClass: "details-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("签收人")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.selectItem.factoryConfirmedName))
          ])
        ])
      : _vm._e(),
    _vm.selectItem.factoryConfirmedTime
      ? _c("div", { staticClass: "details-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("确认时间")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              _vm._s(_vm._f("formateTime")(_vm.selectItem.factoryConfirmedTime))
            )
          ])
        ])
      : _vm._e(),
    _c("div", { staticClass: "details-item" }, [
      _c("div", { staticClass: "title" }, [_vm._v("出库库房")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(_vm._s(_vm.selectItem.warehouseName))
      ])
    ]),
    _c("div", { staticClass: "details-item" }, [
      _c("div", { staticClass: "title" }, [_vm._v("登记时间")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(_vm._s(_vm._f("formateTime")(_vm.selectItem.time)))
      ])
    ]),
    _vm.selectItem.factoryConfirmedStatus == 0
      ? _c(
          "div",
          { staticClass: "footer-btn", on: { click: _vm.signForBtn } },
          [_vm._v(" 确认签收 ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }